/* eslint-disable ember/classic-decorator-hooks, warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import moment from 'moment';

export default class RollReturnDateService extends Service {
  // Services
  @service
  store;

  // State
  @tracked currentReturnDate = null;

  @tracked dates = null;

  init() {
    super.init(...arguments);
    this.store
      .query('nz-roll-returns/return-date', { year: moment().year() })
      .then((dates) => {
        if (!isEmpty(dates)) {
          let currentReturnDate = dates.find(
            (date) => date.status !== 'closed',
          );
          this.dates = dates;
          this.currentReturnDate = currentReturnDate;
        }
      });
  }
}
